// The purpose of this hook is to to set the selected site to the only site whenever the user has multiple sites one site
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isNil from 'lodash/isNil';
import { selectCurrentEmployee, setCurrentEmployeeRequest } from 'store/App';
import { selectCurrentEmployeeManagedSites, selectCurrentEmployeeSite } from 'store/Employers';

const useDefaultFirstSite = () => {
  const dispatch = useDispatch();
  const currentEmployee = useSelector(selectCurrentEmployee());
  const currentEmployeeSites = useSelector(selectCurrentEmployeeManagedSites) || [];
  const currentSite = useSelector(selectCurrentEmployeeSite);
  const firstSite = currentEmployeeSites?.[0];
  const firstSiteId = firstSite?.id;

  const currentSiteId = currentSite?.id;

  useEffect(() => {
    if (firstSiteId && isNil(currentSiteId)) {
      dispatch(setCurrentEmployeeRequest({ ...currentEmployee, siteId: firstSiteId }));
    }
  }, [firstSiteId, currentSiteId, dispatch]);
};

export default useDefaultFirstSite;
